import { useState } from "react";
import { ChevronDown } from "lucide-react";
import SiteOperatorList from "./SiteOperatorList";

const SiteOperatorDisplay = ({
  operators,
  dataId,
  onDelete,
  deleteState,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="main-remark-container">
        <button
          className={`text-dark-blue 2xs:max-lg:text-sm ${
            operators ?? "cursor-pointer"
          } p-4 w-full text-left relative`}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className="font-semibold font-figtree">
            Operator <span>({`${operators ? operators.length : 0}`})</span>
          </span>
          {operators && (
            <ChevronDown
              color="#021472"
              className={`right-5 absolute ${
                open ? "rotate-180 top-3" : "top-4"
              }`}
            />
          )}
        </button>
        {open && (
          <SiteOperatorList
            operators={operators}
            dataId={dataId}
            onDelete={onDelete}
            deleteState={deleteState}
          />
        )}
      </div>
    </>
  );
};
export default SiteOperatorDisplay;
